module.exports = __webpack_public_path__ + "img/20_12.857504ea.png";